module.exports = __webpack_public_path__ + "img/CORSeal-2026.4eba651a.png";